<template>
    <IconBase :class="classes" view-box="0 0 640 512">
        <path d="M64 64V352H576V64H64zM0 64C0 28.7 28.7 0 64 0H576c35.3 0 64 28.7 64 64V352c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V64zM128 448H512c17.7 0 32 14.3 32 32s-14.3 32-32 32H128c-17.7 0-32-14.3-32-32s14.3-32 32-32z"/>
    </IconBase>
</template>

<script>
import IconBase from "./IconBase.vue"

export default {
    components: {
        IconBase
    },
    props: {
        classes: {
            type: String,
            required: false,
            default: ''
        },
    },
}
</script>
